export default __webpack_public_path__ + "static/media/stplabel.c53c8396.svg";